import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'

import { hasValidToken, safeRedirect } from '@/features/auth/session'
import { SignIn } from '@/features/auth/sign-in'

const searchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
  // Why the member is here rather than where they were. `idle` is the dealership's own timeout,
  // which is a rule they should be told about and not a failure of theirs.
  reason: z.enum(['expired', 'idle']).optional().catch(undefined),
})

export const Route = createFileRoute('/login')({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ search }) => {
    if (hasValidToken()) throw redirect({ href: safeRedirect(search.redirect), replace: true })
  },
  component: LoginPage,
})

function LoginPage() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  const target = safeRedirect(search.redirect)

  return (
    <SignIn
      endedBecause={search.reason}
      onSuccess={() => void navigate({ href: target, replace: true })}
    />
  )
}
